module.exports = __webpack_public_path__ + "static/media/gameNft_dark.35ef320f.svg";